import React from "react";
import { PageHeader, Section } from "../components/ui-kit";
import { useContact } from "../context/SiteSettingsContext";

const Block = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-heading text-2xl font-semibold text-stone-900">{heading}</h2>
    <div className="space-y-3 text-lg text-stone-700 leading-relaxed">{children}</div>
  </section>
);

export default function CookiePolicy() {
  const CONTACT = useContact();
  return (
    <>
      <PageHeader
        eyebrow="Cookies"
        title="Cookie Policy"
        intro="This policy explains how Spire Inclusion uses cookies on this website and the choices you have."
        testid="cookie-header"
      />
      <Section tone="white">
        <div className="max-w-3xl space-y-10">
          <Block heading="What cookies are">
            <p>
              Cookies are small text files stored on your device when you visit a website. They help
              websites work and can help us understand how the site is used.
            </p>
          </Block>
          <Block heading="The cookies we use">
            <p>
              <strong>Essential cookies</strong> are needed for the website to work, for example to
              remember your cookie choice. These are always on.
            </p>
            <p>
              <strong>Optional cookies</strong> help us understand how the site is used so we can
              improve it. We only use these if you accept them.
            </p>
          </Block>
          <Block heading="Your choice">
            <p>
              When you first visit, you can accept all cookies or decline optional cookies using the
              banner at the bottom of the page. You can change your choice at any time by clearing
              the cookies in your browser.
            </p>
          </Block>
          <Block heading="Contact us">
            <p>If you have any questions about our use of cookies, contact us at {CONTACT.email}.</p>
          </Block>
        </div>
      </Section>
    </>
  );
}
